import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';

const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

function LawDocuments() {
  const [docs, setDocs] = useState([]);
  const [title, setTitle] = useState('');
  const [url, setUrl] = useState('');
  const [search, setSearch] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);

  const [editing, setEditing] = useState(null);
  const [editError, setEditError] = useState('');
  const [editSaving, setEditSaving] = useState(false);

  const token = localStorage.getItem('token');

  const loadDocs = useCallback(() => {
    axios.get(`${API}/law-documents`, { headers: { authorization: token } })
      .then(res => setDocs(res.data));
  }, [token]);

  useEffect(() => {
    loadDocs();
  }, [loadDocs]);

  const createDoc = async () => {
    setError('');
    setSuccess('');

    if (!title.trim() || !url.trim()) {
      setError(tr("Hujjat nomi va PDF havolasini kiriting"));
      return;
    }

    setSaving(true);
    try {
      await axios.post(`${API}/law-documents/create`, { title, url }, {
        headers: { authorization: token }
      });
      setSuccess(tr("\"{title}\" qo'shildi.", { title }));
      setTitle('');
      setUrl('');
      loadDocs();
    } catch (err) {
      setError(err.response?.data?.error || tr("Hujjat qo'shilmadi."));
    } finally {
      setSaving(false);
    }
  };

  const saveEdit = async () => {
    setEditError('');

    if (!editing.title.trim() || !editing.url.trim()) {
      setEditError(tr("Hujjat nomi va PDF havolasini kiriting"));
      return;
    }

    setEditSaving(true);
    try {
      await axios.put(`${API}/law-documents/${editing.id}`, {
        title: editing.title,
        url: editing.url
      }, { headers: { authorization: token } });

      setSuccess(tr("\"{title}\" yangilandi.", { title: editing.title }));
      setEditing(null);
      loadDocs();
    } catch (err) {
      setEditError(err.response?.data?.error || tr("Saqlanmadi."));
    } finally {
      setEditSaving(false);
    }
  };

  const deleteDoc = async (doc) => {
    setError('');
    setSuccess('');
    if (!window.confirm(tr("\"{title}\" o'chirilsinmi?\n\nBu amalni qaytarib bo'lmaydi.", { title: doc.title }))) return;

    try {
      await axios.delete(`${API}/law-documents/${doc.id}`, { headers: { authorization: token } });
      setSuccess(tr("\"{title}\" o'chirildi.", { title: doc.title }));
      loadDocs();
    } catch (err) {
      setError(err.response?.data?.error || tr("O'chirib bo'lmadi."));
    }
  };

  const query = search.trim().toLowerCase();
  const visible = docs.filter(d => d.title.toLowerCase().includes(query));

  return (
    <div>
      <h2 style={{ marginBottom: '8px', fontSize: '22px' }}>
        {tr("Qonun hujjatlari")}
        <span style={{ marginLeft: '10px', color: '#999', fontSize: '15px', fontWeight: '400' }}>
          {tr("jami {soni} ta", { soni: docs.length })}
        </span>
      </h2>
      <p style={{ marginTop: 0, marginBottom: '20px', color: '#888', fontSize: '13px' }}>
        {tr("Mobil ilovadagi \"Qonun Ustuvorligi\" bo'limida ko'rinadi — xodim bosganda PDF ilova ichida ochiladi.")}
      </p>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)', marginBottom: '24px' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '16px' }}>{tr("Yangi hujjat")}</h3>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '12px' }}>
          <input
            type="text"
            placeholder={tr("Hujjat nomi * (masalan: Jinoyat kodeksi)")}
            value={title}
            onChange={e => setTitle(e.target.value)}
            style={inputStyle}
          />
          <input
            type="text"
            placeholder={tr("PDF havolasi * (masalan: https://server.uz/hujjat.pdf)")}
            value={url}
            onChange={e => setUrl(e.target.value)}
            style={inputStyle}
          />
        </div>

        {error && (
          <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', margin: '12px 0' }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', margin: '12px 0' }}>
            {success}
          </div>
        )}

        <button
          onClick={createDoc}
          disabled={saving}
          style={{
            marginTop: '12px',
            padding: '10px 24px',
            background: saving ? '#888' : '#1a1a2e',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            width: '100%',
            cursor: saving ? 'default' : 'pointer'
          }}
        >
          {saving ? tr("Qo'shilmoqda...") : tr("Qo'shish")}
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
        <input
          type="text"
          placeholder={tr("🔍 Hujjat nomi bo'yicha qidirish...")}
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ ...inputStyle, width: '100%', marginBottom: '16px', boxSizing: 'border-box' }}
        />

        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500', width: '40px' }}>#</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Hujjat nomi")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Havola")}</th>
              <th style={{ textAlign: 'right', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Amallar")}</th>
            </tr>
          </thead>
          <tbody>
            {visible.map((doc, i) => (
              <tr key={doc.id} style={{ borderBottom: '1px solid #f9f9f9' }}>
                <td style={{ padding: '10px 8px', color: '#bbb' }}>{i + 1}</td>
                <td style={{ padding: '10px 8px', fontWeight: '500' }}>{doc.title}</td>
                <td style={{ padding: '10px 8px' }}>
                  <a
                    href={doc.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#4f8ef7', fontSize: '13px' }}
                  >
                    {tr("Ochish ↗")}
                  </a>
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button
                    onClick={() => { setEditError(''); setEditing({ ...doc }); }}
                    style={{ ...smallBtn, marginRight: '6px' }}
                  >
                    {tr("Tahrirlash")}
                  </button>
                  <button onClick={() => deleteDoc(doc)} style={{ ...smallBtn, color: '#c93636' }}>
                    {tr("O'chirish")}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {docs.length === 0 && (
          <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
            {tr("Hali hujjat qo'shilmagan.")}
          </p>
        )}
        {docs.length > 0 && visible.length === 0 && (
          <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
            {tr("\"{search}\" bo'yicha hech narsa topilmadi.", { search })}
          </p>
        )}
      </div>

      {editing && (
        <div
          onClick={() => setEditing(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 100
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '100%', maxWidth: '560px' }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px' }}>{tr("Hujjatni tahrirlash")}</h3>

            <div style={{ display: 'grid', gap: '12px' }}>
              <input
                type="text"
                placeholder={tr("Hujjat nomi")}
                value={editing.title}
                onChange={e => setEditing({ ...editing, title: e.target.value })}
                style={inputStyle}
              />
              <input
                type="text"
                placeholder={tr("PDF havolasi")}
                value={editing.url}
                onChange={e => setEditing({ ...editing, url: e.target.value })}
                style={inputStyle}
              />
            </div>

            {editError && (
              <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginTop: '12px' }}>
                {editError}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button onClick={() => setEditing(null)} style={{ ...smallBtn, padding: '10px 20px', fontSize: '14px' }}>
                {tr("Bekor qilish")}
              </button>
              <button
                onClick={saveEdit}
                disabled={editSaving}
                style={{
                  padding: '10px 24px',
                  background: editSaving ? '#888' : '#1a1a2e',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  cursor: editSaving ? 'default' : 'pointer'
                }}
              >
                {editSaving ? tr("Saqlanmoqda...") : tr("Saqlash")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LawDocuments;
